import React, { useContext, useEffect, useMemo } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import BasketContext from "../services/BasketContext";
import StripeExpressCheckout from "./StripeExpressCheckout";

declare global {
	interface Window {
		StripePublishableApiKey?: string;
		StripeBasketPaymentMethodConfiguration?: string;
	}
}

/**
 * `initialise-payment` now defers shipping (item + tax only) until onShippingRateChange resolves
 * a real option, then the backend updates the Stripe PaymentIntent's amount server-side via
 * StripePaymentIntentShippingUpdateService.
 */
function ExpressStripeWallets(props: { onAvailabilityChange?: (isAvailable: boolean) => void }) {
	const basketContext = useContext(BasketContext);

	const stripePromise = useMemo(() => {
		if (!window.StripePublishableApiKey) {
			return null;
		}
		return loadStripe(window.StripePublishableApiKey);
	}, []);

	const canRender = !!stripePromise && !!basketContext?.basket?.SubTotal?.Price;

	useEffect(() => {
		if (!canRender) {
			props.onAvailabilityChange?.(false);
		}
	}, [canRender]);

	if (!canRender) {
		return null;
	}

	return (
		<Elements
			stripe={stripePromise}
			options={{
				mode: "payment",
				amount: Math.round(basketContext.basket.SubTotal.Price * 100),
				currency: "gbp",
				paymentMethodConfiguration:
					window.StripeBasketPaymentMethodConfiguration || undefined,
				appearance: {
					variables: {
						borderRadius: "0px",
					},
				},
			}}
		>
			<StripeExpressCheckout onAvailabilityChange={props.onAvailabilityChange} />
		</Elements>
	);
}

export default ExpressStripeWallets;
